var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfusion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53516 8.38888C9.53516 7.02801 10.6384 5.9248 11.9992 5.9248C13.3601 5.9248 14.4633 7.02801 14.4633 8.38888C14.4633 9.14771 14.1217 9.82569 13.5797 10.2795C13.061 10.7138 12.4004 11.2694 11.8773 11.9191C11.3484 12.576 10.8742 13.4322 10.8742 14.478V15.3003C10.8742 15.9216 11.3779 16.4253 11.9992 16.4253C12.6206 16.4253 13.1242 15.9216 13.1242 15.3003V14.478C13.1242 14.143 13.2721 13.7744 13.6298 13.3302C13.9933 12.8787 14.4841 12.4567 15.0241 12.0046C16.0548 11.1417 16.7133 9.84165 16.7133 8.38888C16.7133 5.78537 14.6027 3.6748 11.9992 3.6748C9.39572 3.6748 7.28516 5.78537 7.28516 8.38888C7.28516 9.0102 7.78884 9.51388 8.41016 9.51388C9.03148 9.51388 9.53516 9.0102 9.53516 8.38888Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 17.7758C11.2939 17.7758 10.723 18.3466 10.723 19.0508C10.723 19.7549 11.2939 20.3258 11.998 20.3258C12.7022 20.3258 13.274 19.7549 13.274 19.0508C13.274 18.3466 12.7022 17.7758 11.998 17.7758Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfusion);
export default __webpack_public_path__ + "static/media/Confusion.80c27dd7664b632f679eaa9a0da281d9.svg";
export { ForwardRef as ReactComponent };